import { Form, Select } from 'antd'
import { LabeledValue } from 'antd/lib/select'
import { OptionData, OptionGroupData } from 'rc-select/lib/interface'
import { FC, KeyboardEvent, useRef, useEffect, useState } from 'react'

import Text from '~/core/Text'

import { emailValidator } from './logic'
import styles from './styles.css'

type EmailAddressesFormPropsType = {
    onFormChanged: Function
    setSubmitDisabled?: Function
    hasError?: boolean
    showLabel?: boolean
    clearForm?: boolean
}

const EMAIL_ADDRESS_FIELD = 'emailAddressField'

export const EMAIL_ADDRESSES = 'emailAddresses'

const EmailAddressesForm: FC<EmailAddressesFormPropsType> = ({
    onFormChanged,
    hasError,
    showLabel,
    clearForm,
}) => {
    const inputRef = useRef<any>(null)
    const [form] = Form.useForm()

    const [selectedOptions, setSelectedOptions] = useState<
        string[] | undefined
    >([])

    useEffect(() => {
        if (clearForm) {
            form.resetFields()
        }
    }, [form, clearForm])

    useEffect(() => {
        inputRef?.current?.focus()
    }, [])

    const onInputKeyDown = (evt: KeyboardEvent) => {
        evt.persist()
        setTimeout(() => {
            const target = evt.target as HTMLInputElement

            const emailAddresses = form.getFieldValue(EMAIL_ADDRESS_FIELD)

            if (hasError && emailAddresses.length > 0) {
                return
            }

            if (target.value !== '') {
                onFormChanged({ error: false })
            }
        }, 10)
    }

    const handleDeselect = (value: string | (EventTarget & HTMLElement)) => {
        if (value instanceof HTMLInputElement) {
            value = value.value
        }
        if (selectedOptions) {
            setSelectedOptions(selectedOptions.filter(o => o !== value))
        }
    }

    const handleSelect = (value: string | (EventTarget & HTMLElement)) => {
        if (value instanceof HTMLInputElement) {
            value = value.value
        }
        selectedOptions?.push(value as string)
        setSelectedOptions(selectedOptions)
    }

    return (
        <Form
            style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
            form={form}
        >
            {showLabel && (
                <Text
                    fontWeight={500}
                    style={{ marginBottom: '12px' }}
                    fontSize={'14px'}
                >
                    Enter email address(es) below
                </Text>
            )}
            <Form.Item
                style={{ marginBottom: '4px' }}
                className={styles.emailForm}
                name={EMAIL_ADDRESS_FIELD}
                rules={[
                    {
                        validator: (
                            _rule: any,
                            values: string[],
                            callback: Function,
                        ) => emailValidator(onFormChanged, values, callback),
                    },
                ]}
            >
                <Select
                    placeholder="Type the full email address here"
                    mode="tags"
                    tokenSeparators={[',', ' ', '\n', '\t']}
                    onInputKeyDown={onInputKeyDown}
                    showSearch
                    notFoundContent={null}
                    onSelect={
                        handleSelect as unknown as
                            | ((
                                  value: LabeledValue | undefined,
                                  option: OptionData | OptionGroupData,
                              ) => void)
                            | undefined
                    }
                    onDeselect={
                        handleDeselect as unknown as
                            | ((
                                  value: LabeledValue | undefined,
                                  option: OptionData | OptionGroupData,
                              ) => void)
                            | undefined
                    }
                    ref={inputRef}
                    onBlur={event => handleSelect(event.target)}
                    open={false}
                />
            </Form.Item>
        </Form>
    )
}

export default EmailAddressesForm
